import React, { useState } from 'react';
import { Col, Row } from 'antd';
import StandardCard from '../StandardCard/StandardCard';
import FileDetail from '../FileDetail/FileDetail';

/**
 * 文件卡片组组件
 * @param {Object} props
 * @param {Array} props.files - 文件数组
 * @param {string} props.title - 标题
 * @param {boolean} props.isHandbook - 是否为产品手册
 */
export default function CardGroup({ files = [], title, isHandbook = false }) {
  const [isShow, setIsShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);

  console.log(files, title, "产品手册测试");

  return (
    <div className='singular-row'>
      <Row gutter={[20, 20]}>
        {files.map((file, index) => (
          <Col
            key={file.id}
            span={6}
          >
            <StandardCard
              file={file}
              mark={index}
              isShow={isShow}
              currentIndex={currentIndex}
              updateIndex={setCurrentIndex}
              updateIsShow={setIsShow}
              title={title}
              isHandbook={isHandbook} // 传递给 StandardCard
            />
          </Col>
        ))}
      </Row>
      {isShow && <FileDetail data={files[currentIndex]} />}
    </div>
  );
}
